import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import * as React from 'react';
import PageHeaderDialogs from '../../../../enums/PageHeaderDialogs';
import { communicatorRoute } from '../../../../routes';
import { useDialerIsReady } from '../../../../store/dialer';
import { useAppSelector } from '../../../../store/hooks';
import { NavQuickCall } from '../../../Dialer/QuickCall/NavQuickCall';
import NavLinkMenuItem from '../../NavLinkMenuItem/NavLinkMenuItem';
import { NavAccountSetupButton } from '../../PageHeader/NavAccountSetupButton';
import HeaderActionsDialerStatus from '../../PageHeader/PageHeaderActions/HeaderActionsDialerStatus';
import { UserEmailSetupButton } from '../../PageHeader/UserEmailSetupButton';

interface Props {
    anchorEl: HTMLElement | null;
    menuId: string;
    onOpenDialogHandler: (event: React.MouseEvent<HTMLElement>) => void;
    onCloseHandler: () => void;
}

export default function MenuPageHeaderActionsRaw({
    anchorEl,
    menuId,
    onOpenDialogHandler,
    onCloseHandler,
}: Props) {
    const dialerIsReady = useDialerIsReady();
    const isImpersonated = useAppSelector(state => state.user.isImpersonated);
    const isDialerBootstrapped = useAppSelector(state => state.dialer.isBootstrapped);
    const dialerDeviceCount = useAppSelector(
        state => state.dialer.twilioDevice?.audioDevices.length || 0,
    );

    return (
        <Menu id={menuId} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onCloseHandler}>
            {
                //if no device registered or impersonated, show dialer status
                (isDialerBootstrapped || isImpersonated) && (
                    <HeaderActionsDialerStatus
                        isImpersonated={isImpersonated}
                        isCompOnMenu={true}
                        isDialerBootstrapped={isDialerBootstrapped}
                        twilioDeviceCount={dialerDeviceCount}
                    />
                )
            }
            <UserEmailSetupButton isMenuItem={true} />
            <NavAccountSetupButton isMenuItem={true} />
            {dialerIsReady && <NavQuickCall isCompOnMenu={true} />}
            <MenuItem data-name={PageHeaderDialogs.createContact} onClick={onOpenDialogHandler}>
                <ListItemIcon>
                    <PersonAddIcon />
                </ListItemIcon>
                <ListItemText primary="Create Contact" />
            </MenuItem>
            <NavLinkMenuItem pathname={communicatorRoute}>
                <ListItemIcon>
                    <PermPhoneMsgIcon />
                </ListItemIcon>
                <ListItemText primary="Schedule Messages" />
            </NavLinkMenuItem>
        </Menu>
    );
}
